/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/users/customers",
    },
    (router) => {
      router.push({
        id: "@api/user.customer@create",
        path: "",
      });

      router.group(
        {
          path: "/:userCustomerId",
        },
        (router) => {
          router.push({
            id: "@api/user.customer@show",
            path: "",
          });
          router.push({
            id: "@api/user.customer@update",
            path: "",
          });
        },
      );

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/user.customer@autocomplete",
            path: "/autocomplete",
          });
        },
      );
    },
  );
}
